import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { useEffect, useId, useRef, useState } from 'react'
import { sendDatalayerEvent } from '../utils/sendDatalayerEvent'

interface Props {
  url: string
}

const Iframe = styled.iframe`
  width: 100%;
  height: auto;
`
const CenterContainer = styled.div(
  () => css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 300px;
  `,
)

const LoadingIndicator = styled.div(
  ({ theme }) => css`
    width: 40px;
    height: 40px;
    border: 4px solid ${theme.colors.neutral1};
    border-radius: 50%;
    border-top-color: ${theme.colors.primaryBlue};
    animation: spin 1.2s linear infinite;

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `,
)

const YellowYardForm = ({ url }: Props) => {
  const id = useId()
  const ref = useRef<HTMLIFrameElement>(null)

  const [loading, setLoading] = useState(true)
  const [formHeight, setFormHeight] = useState(0)

  useEffect(() => {
    const abortController = new AbortController()
    const { signal } = abortController

    window?.addEventListener(
      'message',
      (e) => {
        const typedEvent = e as MessageEvent
        // eslint-disable-next-line no-console
        console.debug(typedEvent)
        if (!typedEvent || typeof typedEvent.data !== 'object') {
          // eslint-disable-next-line no-console
          console.log('Geen data ontvangen')
        } else if (typedEvent.data.applied) {
          // TODO: Send GTM event
          sendDatalayerEvent({
            event: 'applied',
            virtual_url: window.location.href,
            virtual_title: document.title,
            yellowyardUrl: ref.current?.src,
          })
          // eslint-disable-next-line no-console
          console.log(`Gesolliciteerd op: ${typedEvent.data.applied}`)
        } else if (typedEvent.data.dataType === 'YellowYardIframeHeight') {
          if (ref.current === null) {
            return
          }
          setFormHeight(parseInt(typedEvent.data.height, 10))
        }
      },
      { signal },
    )
    return () => {
      abortController.abort()
    }
  }, [])

  return (
    <>
      {loading && (
        <CenterContainer>
          <LoadingIndicator />
        </CenterContainer>
      )}
      <Iframe
        id={id}
        ref={ref}
        src={url}
        title="YellowYard Application Form"
        loading="lazy"
        style={{ height: loading ? '0px' : `${formHeight}px` }}
        onLoad={() => setLoading(false)}
      />
    </>
  )
}

export default YellowYardForm
